import {
  useAssignSetting,
  useSetting,
} from "@faire/retailer-visitor-shared/settings/__internal__/useSetting";
import { ISearchSuggestionHoverXP } from "@faire/web-api--source/indigofair/data/ISearchSuggestionHoverXP";
import { LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130 } from "@faire/web-api--source/indigofair/settings/LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130";

export const useSettingSearchSuggestionHoverSpeculationRelaunch =
  (): ISearchSuggestionHoverXP => {
    return useSetting(
      LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130,
      ISearchSuggestionHoverXP.Bucket.CONTROL
    );
  };

export const useAssignSettingSearchSuggestionHoverSpeculationRelaunch = () =>
  useAssignSetting(LISP_SUGGESTION_HOVER_SPECULATION_RELAUNCH_250130);
